var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"al"},[_c('h1',{staticClass:"h1"},[_vm._v("活动快速通道🔜")]),_vm._l((_vm.list.routes),function(item,index){return _c('van-cell',{key:index,attrs:{"is-link":"","to":'/' + item.baseUrl}},[_vm._v("\n    "+_vm._s(item.pageTitle)+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }